import React, { useEffect } from "react"
import "../scss/HeritagePageText4.scss"
import { graphql, useStaticQuery } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Aos from "aos"
import "aos/dist/aos.css"
import { Helmet } from "react-helmet";

export default function HeritagePageText4() {
  const data = useStaticQuery(graphql`
    query MyQuery2601 {
      allContentfulTextBlock(filter: { id: { eq: "71e9c1b1-9a98-5e24-9cb2-f363186ce0b8" } }) {
        edges {
          node {
            bodyText {
              raw
            }
            title
            id
          }
        }
      }
    }
  `)

  useEffect(() => {
    Aos.init({ duration: 1000 })
  }, [])

  if (data.allContentfulTextBlock.edges.length === 0) {
    return null; // Handle the case when the desired node is not found
  }

  const { bodyText, title } = data.allContentfulTextBlock.edges[0].node

  return (
    <>
      <Helmet>
        <h2>Based in London’s Culturally Rich Heritage</h2>
        <h3>Culturally Diverse and Rich</h3>
      </Helmet>
    <div className="contentFeatureHeritageText4">
      <div className="textContainerHeritageText4">
        <p className="titleHeritageText4">{title}</p>
        {bodyText && (
          <div className="bodyHeritageText4">
            {documentToReactComponents(JSON.parse(bodyText.raw))}
          </div>
        )}
      </div>
    </div>
    </>
  )
}
